import React from "react";
import Routes from "./Routes";
// import { UserProvider } from '@/contexts/UserContext';
import ChatWrapper from './components/chat/ChatWrapper';
import SystemModalWrapper from './components/announcements/SystemModalWrapper';


function App() { 

return (
<>
<Routes />
{/*<ChatWrapper />*/}
<SystemModalWrapper/>
</>
);
}

export default App;
